import CardSlot from '@/pages/intelligence/components/CardSlot';
import React, { useMemo } from 'react';
import GameImage from '@/pages/home/components/GameImage';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import { useRequest } from 'ahooks';
import { fetchCompaniesNewsActivityFullNameData } from '@/pages/intelligence/services/topcharts';
import { history, useIntl } from 'umi';
import { PLACEHOLDER } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import './index.scss';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';

const PLATFORM_MAP: { [keyName: string]: string } = {
  mobile: 'mobile',
  pc: 'pc',
  console: 'console',
};
const SOURCE_MAP: { [keyName: string]: string } = {
  upcoming: 'Upcoming',
  'new release': 'NewRelease',
};

const NewGames = (porps: any) => {
  const { loading, data, companyId, entityType } = porps;

  const { formatMessage } = useIntl();

  const { data: fullNameData, loading: fullNameLoading } = useRequest(
    fetchCompaniesNewsActivityFullNameData,
    {
      defaultParams: [
        {
          company_id: companyId,
          entity_type: entityType,
        },
      ],
    },
  );

  const fullName = useMemo(() => {
    if (fullNameLoading || !fullNameData?.company_name?.[0]) return [];

    return fullNameData?.company_name?.[0];
  }, [fullNameLoading]);

  return (
    <CardSlot
      className="dbi-new-games"
      title={formatMessage({ id: 'dbi_company_new_games' })}
      isAction={true}
      iconList={[]}
      getDetails={() => {
        const filter = encodeURIComponent(
          JSON.stringify({
            companyName: fullName || '',
          }),
        );
        const url = `/intelligence/topCharts/${
          PLATFORM_MAP?.[data?.[0]?.entityType?.toLowerCase()] || 'mobile'
        }Games/${SOURCE_MAP?.[data?.[0]?.source?.toLowerCase()] || 'NewRelease'}?filter=${filter}`;
        history?.push(url);
      }}
    >
      <Abnormal
        isLoading={loading || fullNameLoading}
        isError={false}
        isNoData={!data || (Array.isArray(data) && !data?.length)}
        component={
          <>
            {Array.isArray(data) &&
              !!data?.length &&
              data.map((e: any, i: any) => <ItenBox key={i} data={e} />)}
          </>
        }
      />
    </CardSlot>
  );
};

export default NewGames;

const ItenBox = (porps: any) => {
  const { data } = porps;

  const genres = data?.list?.filter((item: any) => item?.trim()?.length > 0);

  const getDetailGamePath = () => {
    return getDetailGamePathCommon({
      entityType: data?.entityType?.toLowerCase(),
      gameId: data?.eu_id,
      tab: 'overview',
      subTab: '',
    });
  };
  const onClickGame = () => {
    history.push(getDetailGamePath());
  };

  return (
    <div className="games-item">
      <ARightClickToJump href={getDetailGamePath()} style={{ display: 'inline' }}>
        <div className="games-item-left">
          {/* <img
          src={data.img}
          className={data.type == 1 ? 'message-img-one' : data.type == 2 ? 'message-img-two' : 'message-img-three'}
        /> */}
          <GameImage
            className={
              data.type === 1
                ? 'message-img-one'
                : data.type === 2
                ? 'message-img-two'
                : 'message-img-three'
            }
            entityType={data.type === 1 ? 'mobile' : data.type === 2 ? 'pc' : 'console'}
            src={data.img}
            onClick={onClickGame}
          />
          <div className="message-text">
            <div className="text-title" onClick={onClickGame}>
              {data.title}
            </div>
            <div className="text-tip">
              {genres?.length > 0 || PLACEHOLDER}
              {genres?.length > 0 && (
                <>
                  {genres?.map((e: any, i: any) => (
                    <span className="tip-item" key={i}>
                      {e}
                    </span>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </ARightClickToJump>
      <div className="games-item-right">
        <div className="message-text">
          {/* <img src={data.svg} className="text-img" /> */}
          {/* <span className="text-tip">{data.name}</span> */}
          {data.name}
        </div>
        <div className="text-time">{data.time}</div>
      </div>
    </div>
  );
};
